export const removeUtmQueries = (url: string | null): string => {
  if (!url) return '';

  const [path, queryString] = url.split('?');

  if (!queryString) return path;

  const params = new URLSearchParams(queryString);

  // Remove all parameters that start with `utm_`
  for (const key of Array.from(params.keys())) {
    if (key.startsWith('utm_')) {
      params.delete(key);
    }
  }

  return params.toString() ? `${path}?${params.toString()}` : path;
};
